import React from 'react';
import { Link } from 'react-router-dom';
import { bool, func, shape, string } from 'prop-types';
import { Box, TableCell, TableRow, useTheme } from '@mui/material';

import { ActionMenu, Status } from './components';
import PermissionGate from '../../../../../../../../components/PermissionGate';

import { ACTIONS, getActions, getStatusText } from '../../../../utils/webhookConfig';
import { TYPES } from '../../../../utils/webhookTypes';

import { Chip } from '../../../../../../../../components';

const WebhooksStatusRow = ({
  webhook, actions, disabled, applicationId,
}) => {
  const {
    disabledReason, name, id, status, type,
  } = webhook;

  const { selectWebhook, toggleWebhookModal } = actions;

  const openModal = (modalName) => {
    toggleWebhookModal({ nextModal: modalName, curModal: null });
  };

  const theme = useTheme();

  return (
    <TableRow>
      <TableCell sx={{ color: disabled && theme.palette.grey[500] }}>
        <span>
          {disabled ? name : (
            <Link to={`/apps/${applicationId}/webhooks/${id}`} onClick={() => selectWebhook(id)}>
              {name}
            </Link>
          )}
        </span>
        {type && <Box ml={1} component="span"><Chip label={TYPES[type].text} /></Box>}
      </TableCell>
      <TableCell sx={{ color: disabled && theme.palette.grey[500] }}>
        <Status
          statusText={getStatusText(status)}
          hasError={disabledReason === 'error'}
          disabled={disabled}
        />
      </TableCell>
      <TableCell sx={{ color: disabled && theme.palette.grey[500] }}>
        {webhook.updatedAt || webhook.createdAt}
      </TableCell>
      <TableCell sx={{ textAlign: 'right' }}>
        <PermissionGate
          dashboardPermission="write_webhooks"
          alternateComponent={
            <ActionMenu
              webhookId={id}
              selectWebhook={() => selectWebhook(id)}
              actions={[ACTIONS.VIEW]}
              openModal={openModal}
              disabled={disabled}
            />
          }
        >
          <ActionMenu
            webhookId={id}
            selectWebhook={selectWebhook}
            actions={getActions(status)}
            openModal={openModal}
            disabled={disabled}
          />
        </PermissionGate>
      </TableCell>
    </TableRow>
  );
};

export default WebhooksStatusRow;

WebhooksStatusRow.propTypes = {
  webhook: shape({
    disabledReason: string,
    name: string.isRequired,
    id: string.isRequired,
    status: string.isRequired,
  }).isRequired,
  actions: shape({
    selectWebhook: func.isRequired,
    toggleWebhookModal: func.isRequired,
  }).isRequired,
  disabled: bool,
  applicationId: string.isRequired,
};

WebhooksStatusRow.defaultProps = {
  disabled: false,
};
